//function to input uppercase
export const toInputUpperCase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
}